var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "status-admin-card", attrs: { flat: "" } },
    [
      _c(
        "v-card-text",
        { staticClass: "pa-3" },
        [
          _vm.form.banner && _vm.form.bannerText
            ? _c("div", { staticClass: "preview-wrapper mb-2" }, [
                _c("span", { staticClass: "preview-label" }, [
                  _vm._v(_vm._s(_vm.$t("preview"))),
                ]),
                _c(
                  "div",
                  {
                    staticClass: "status-preview",
                    class: _vm.statusPreviewClass,
                  },
                  [
                    _c("v-icon", { attrs: { color: "white", size: "16" } }, [
                      _vm._v(_vm._s(_vm.currentStatusConfig.icon)),
                    ]),
                    _vm.previewCountdownText
                      ? _c("span", { staticClass: "countdown-badge" }, [
                          _vm._v(_vm._s(_vm.previewCountdownText)),
                        ])
                      : _vm._e(),
                    _c("span", { staticClass: "preview-text" }, [
                      _vm._v(
                        _vm._s(
                          _vm.form.bannerText || _vm.$t("banner-placeholder")
                        )
                      ),
                    ]),
                    _vm.form.dismissable
                      ? _c(
                          "v-icon",
                          {
                            staticClass: "dismiss-icon",
                            attrs: { color: "white", size: "14" },
                          },
                          [_vm._v(" mdi-close ")]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "master-toggle mb-2" },
            [
              _c("v-switch", {
                staticClass: "mt-0",
                attrs: { inset: "", "hide-details": "", dense: "" },
                scopedSlots: _vm._u([
                  {
                    key: "label",
                    fn: function () {
                      return [
                        _c(
                          "span",
                          { staticClass: "font-weight-medium text-body-2" },
                          [_vm._v(_vm._s(_vm.$t("status-system-enabled")))]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.form.enabled,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "enabled", $$v)
                  },
                  expression: "form.enabled",
                },
              }),
            ],
            1
          ),
          _c("v-expand-transition", [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.form.enabled,
                    expression: "form.enabled",
                  },
                ],
              },
              [
                _c("div", { staticClass: "section-card mb-2" }, [
                  _c(
                    "div",
                    { staticClass: "section-header" },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mr-1", attrs: { "x-small": "" } },
                        [_vm._v("mdi-traffic-light")]
                      ),
                      _vm._v(" " + _vm._s(_vm.$t("system-status")) + " "),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "status-buttons" },
                    _vm._l(_vm.statusOptions, function (opt) {
                      return _c(
                        "button",
                        {
                          key: opt.value,
                          staticClass: "status-btn",
                          class: { active: _vm.form.status === opt.value },
                          style:
                            _vm.form.status === opt.value
                              ? `--active-color: ${opt.hex}`
                              : "",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              _vm.form.status = opt.value
                            },
                          },
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              attrs: {
                                "x-small": "",
                                color:
                                  _vm.form.status === opt.value
                                    ? "white"
                                    : opt.color,
                              },
                            },
                            [_vm._v(" " + _vm._s(opt.icon) + " ")]
                          ),
                          _c("span", [_vm._v(_vm._s(opt.label))]),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ]),
                _c("div", { staticClass: "section-card mb-2" }, [
                  _c(
                    "div",
                    { staticClass: "section-header" },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mr-1", attrs: { "x-small": "" } },
                        [_vm._v("mdi-message-alert-outline")]
                      ),
                      _vm._v(
                        " " + _vm._s(_vm.$t("banner-configuration")) + " "
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "section-content" },
                    [
                      _c(
                        "div",
                        { staticClass: "toggle-row" },
                        [
                          _c("v-switch", {
                            staticClass: "mt-0 compact-switch",
                            attrs: { dense: "", "hide-details": "" },
                            scopedSlots: _vm._u([
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "text-caption" },
                                      [_vm._v(_vm._s(_vm.$t("show-banner")))]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.form.banner,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "banner", $$v)
                              },
                              expression: "form.banner",
                            },
                          }),
                          _c("v-switch", {
                            staticClass: "mt-0 ml-4 compact-switch",
                            attrs: {
                              dense: "",
                              "hide-details": "",
                              disabled: !_vm.form.banner,
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "label",
                                fn: function () {
                                  return [
                                    _c(
                                      "span",
                                      { staticClass: "text-caption" },
                                      [_vm._v(_vm._s(_vm.$t("dismissable")))]
                                    ),
                                  ]
                                },
                                proxy: true,
                              },
                            ]),
                            model: {
                              value: _vm.form.dismissable,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "dismissable", $$v)
                              },
                              expression: "form.dismissable",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("v-text-field", {
                        staticClass: "mt-2",
                        attrs: {
                          label: _vm.$t("banner-message"),
                          placeholder: _vm.$t("banner-placeholder"),
                          outlined: "",
                          dense: "",
                          "hide-details": "",
                          disabled: !_vm.form.banner,
                        },
                        model: {
                          value: _vm.form.bannerText,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "bannerText", $$v)
                          },
                          expression: "form.bannerText",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "section-card mb-2" }, [
                  _c(
                    "div",
                    { staticClass: "section-header" },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mr-1", attrs: { "x-small": "" } },
                        [_vm._v("mdi-lock-outline")]
                      ),
                      _vm._v(
                        " " + _vm._s(_vm.$t("overlay-configuration")) + " "
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "section-content" },
                    [
                      _c("v-switch", {
                        staticClass: "mt-0 compact-switch",
                        attrs: { dense: "", "hide-details": "" },
                        scopedSlots: _vm._u([
                          {
                            key: "label",
                            fn: function () {
                              return [
                                _c("span", { staticClass: "text-caption" }, [
                                  _vm._v(_vm._s(_vm.$t("block-application"))),
                                ]),
                                _c(
                                  "v-menu",
                                  {
                                    attrs: {
                                      "close-on-content-click": false,
                                      "open-on-hover":
                                        !_vm.$vuetify.breakpoint.xs,
                                      "offset-y": "",
                                      top: "",
                                      "max-width": "400",
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "activator",
                                        fn: function ({ on, attrs }) {
                                          return [
                                            _c(
                                              "v-chip",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    staticClass: "ml-2",
                                                    attrs: {
                                                      "x-small": "",
                                                      color: "error",
                                                      "text-color": "white",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        $event.stopPropagation()
                                                        _vm.overlayPreviewOpen =
                                                          !_vm.overlayPreviewOpen
                                                      },
                                                    },
                                                  },
                                                  "v-chip",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t("full-page")
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                      },
                                    ]),
                                    model: {
                                      value: _vm.overlayPreviewOpen,
                                      callback: function ($$v) {
                                        _vm.overlayPreviewOpen = $$v
                                      },
                                      expression: "overlayPreviewOpen",
                                    },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "overlay-preview-wrapper",
                                        class: _vm.previewStatusClass,
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass:
                                              "overlay-preview-label",
                                          },
                                          [_vm._v(_vm._s(_vm.$t("preview")))]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "overlay-preview-content",
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "preview-icon-container",
                                                class: _vm.previewStatusClass,
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      size: "48",
                                                      color: "white",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.currentStatusConfig
                                                          .icon
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                            _c(
                                              "h2",
                                              { staticClass: "preview-title" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.previewOverlayTitle
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _vm.form.bannerText
                                              ? _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "preview-message",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.form.bannerText
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.maintenanceWindow &&
                                            _vm.maintenanceWindow
                                              .minutesRemaining
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "preview-countdown",
                                                  },
                                                  [
                                                    _c(
                                                      "v-icon",
                                                      {
                                                        staticClass: "mr-2",
                                                        attrs: {
                                                          color: "white",
                                                          size: "18",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          "mdi-clock-outline"
                                                        ),
                                                      ]
                                                    ),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "estimated-time-remaining"
                                                          )
                                                        ) +
                                                          ": " +
                                                          _vm._s(
                                                            _vm
                                                              .maintenanceWindow
                                                              .minutesRemaining
                                                          ) +
                                                          " " +
                                                          _vm._s(
                                                            _vm.$t("minutes")
                                                          )
                                                      ),
                                                    ]),
                                                  ],
                                                  1
                                                )
                                              : _vm._e(),
                                            _c("v-progress-linear", {
                                              staticClass: "preview-progress",
                                              attrs: {
                                                indeterminate: "",
                                                rounded: "",
                                                height: "5",
                                                color: "white",
                                              },
                                            }),
                                            _c(
                                              "p",
                                              { staticClass: "preview-hint" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        "overlay-wait-message"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "v-btn",
                                              {
                                                staticClass:
                                                  "preview-devops-btn",
                                                attrs: {
                                                  text: "",
                                                  "x-small": "",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.stopPropagation()
                                                    _vm.overlayPreviewOpen = false
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      left: "",
                                                      "x-small": "",
                                                    },
                                                  },
                                                  [_vm._v("mdi-shield-account")]
                                                ),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.$t("devops-bypass")
                                                    ) +
                                                    " "
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.form.overlay,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "overlay", $$v)
                          },
                          expression: "form.overlay",
                        },
                      }),
                      _vm.form.overlay
                        ? _c(
                            "v-alert",
                            {
                              staticClass: "mt-2 mb-0 text-caption",
                              attrs: { dense: "", type: "warning" },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("overlay-warning")) + " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _c("div", { staticClass: "section-card" }, [
                  _c(
                    "div",
                    { staticClass: "section-header" },
                    [
                      _c(
                        "v-icon",
                        { staticClass: "mr-1", attrs: { "x-small": "" } },
                        [_vm._v("mdi-calendar-clock")]
                      ),
                      _vm._v(
                        " " + _vm._s(_vm.$t("scheduled-maintenance")) + " "
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "section-content" },
                    [
                      _c(
                        "v-row",
                        { attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t("start-time"),
                                  type: "datetime-local",
                                  outlined: "",
                                  dense: "",
                                  "hide-details": "",
                                  "append-icon": _vm.form.maintenanceStart
                                    ? "mdi-close"
                                    : "",
                                },
                                on: {
                                  "click:append": function ($event) {
                                    _vm.form.maintenanceStart = null
                                  },
                                },
                                model: {
                                  value: _vm.form.maintenanceStart,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "maintenanceStart", $$v)
                                  },
                                  expression: "form.maintenanceStart",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t("end-time"),
                                  type: "datetime-local",
                                  outlined: "",
                                  dense: "",
                                  "hide-details": "",
                                  "append-icon": _vm.form.maintenanceEnd
                                    ? "mdi-close"
                                    : "",
                                },
                                on: {
                                  "click:append": function ($event) {
                                    _vm.form.maintenanceEnd = null
                                  },
                                },
                                model: {
                                  value: _vm.form.maintenanceEnd,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "maintenanceEnd", $$v)
                                  },
                                  expression: "form.maintenanceEnd",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-row",
                        { staticClass: "mt-1", attrs: { dense: "" } },
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "6", sm: "4" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t("alert-before"),
                                  type: "number",
                                  suffix: "min",
                                  outlined: "",
                                  dense: "",
                                  "hide-details": "",
                                },
                                model: {
                                  value: _vm.form.alertBeforeMins,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.form,
                                      "alertBeforeMins",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "form.alertBeforeMins",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm.hasScheduledMaintenance
                        ? _c(
                            "v-alert",
                            {
                              staticClass: "mt-2 mb-0 text-caption",
                              attrs: {
                                dense: "",
                                type: _vm.maintenanceAlertType,
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.maintenanceAlertText) + " "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
              ]
            ),
          ]),
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-card-actions",
        { staticClass: "pa-2" },
        [
          _c(
            "v-btn",
            {
              attrs: { text: "", "x-small": "" },
              on: { click: _vm.resetForm },
            },
            [
              _c("v-icon", { attrs: { left: "", "x-small": "" } }, [
                _vm._v("mdi-refresh"),
              ]),
              _vm._v(" " + _vm._s(_vm.$t("reset")) + " "),
            ],
            1
          ),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: {
                color: "primary",
                small: "",
                loading: _vm.loading,
                disabled: !_vm.hasChanges,
              },
              on: { click: _vm.saveStatus },
            },
            [
              _c("v-icon", { attrs: { left: "", "x-small": "" } }, [
                _vm._v("mdi-content-save"),
              ]),
              _vm._v(" " + _vm._s(_vm.$t("save-changes")) + " "),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }